import { useState } from "react";

type Review = { name: string; role: string; color: string; comment: string; fav: string };

const REVIEWS: Review[] = [
  {
    name: "加班不加糖",
    role: "互联网打工人",
    color: "bg-orange-500",
    comment:
      "下饭神器实锤了！地铁上点开一条就笑到旁边大爷问我怎么了，从此我的通勤不再是噩梦，是剧场。",
    fav: "最爱看：地铁偶遇系列",
  },
  {
    name: "阿哲不吃瓜",
    role: "资深吃瓜群众",
    color: "bg-teal-500",
    comment:
      "作为一个围观过无数名场面的人，这里的被怼金句每条都是精华，比剧本精彩多了，真实感拉满。",
    fav: "最爱看：被怼金句栏目",
  },
  {
    name: "小周要开心",
    role: "社恐本人",
    color: "bg-amber-500",
    comment:
      "看这些翻车现场莫名治愈，原来不是只有我搭话会冷场。看完突然觉得自己的尴尬瞬间也没那么社死。",
    fav: "最爱看：尴尬瞬间小剧场",
  },
  {
    name: "Kevin 在沪漂",
    role: "销售从业者",
    color: "bg-rose-500",
    comment:
      "评论区比正片还有意思，大家都太会总结了。建议增加“本期最佳嘴替”评选，我一定天天蹲更新。",
    fav: "最爱看：评论区名场面",
  },
  {
    name: "蘑菇炖土豆",
    role: "学生党",
    color: "bg-lime-600",
    comment:
      "每天中午吃饭固定节目，更新也够快。唯一缺点是广告植入让我笑点低了，看啥都容易笑出声。",
    fav: "最爱看：咖啡店系列",
  },
  {
    name: "Linlin",
    role: "内容创作者",
    color: "bg-cyan-600",
    comment:
      "选题和剪辑节奏都很顶，名场面节奏卡点精准。这波围观的含金量，懂的都懂，必须一键三连。",
    fav: "最爱看：名场面TOP榜",
  },
];

export default function Reviews() {
  const [checked, setChecked] = useState<number[]>([]);
  const toggle = (i: number) =>
    setChecked((c) => (c.includes(i) ? c.filter((x) => x !== i) : [...c, i]));

  return (
    <section id="reviews" className="bg-orange-50/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 text-center md:mb-10">
          <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-teal-500 px-3 py-1 text-xs font-semibold text-white">
            <i className="ri-chat-heart-fill" /> 真实用户口碑
          </p>
          <h2 className="font-hand text-3xl text-stone-900 md:text-4xl">吃瓜群众的真实评价</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-stone-500 md:text-base">
            搭讪吃瓜致力于做最下饭的搭讪翻车名场面聚集地，把每天的真实社死瞬间，变成大家共同的快乐源泉。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <figure
              key={r.name}
              className="flex flex-col rounded-2xl border border-stone-200 bg-white p-5 transition-shadow hover:shadow-md md:p-6"
            >
              <div className="flex items-center gap-3">
                <span
                  className={`grid h-11 w-11 shrink-0 place-items-center rounded-full text-sm font-bold text-white ${r.color}`}
                >
                  {r.name.slice(0, 1)}
                </span>
                <div className="min-w-0 flex-1">
                  <figcaption className="truncate text-sm font-semibold text-stone-900">{r.name}</figcaption>
                  <p className="text-xs text-stone-400">{r.role}</p>
                </div>
                <span className="flex text-amber-400" aria-label="五星好评">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <i key={s} className="ri-star-fill text-sm" />
                  ))}
                </span>
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-stone-600">
                “{r.comment}”
              </blockquote>
              <div className="mt-4 flex items-center justify-between border-t border-stone-100 pt-3">
                <span className="text-xs text-stone-400">{r.fav}</span>
                <button
                  onClick={() => toggle(i)}
                  aria-label="这条评价是否有帮助"
                  className={`inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold transition-colors ${
                    checked.includes(i) ? "text-orange-500" : "text-stone-400 hover:text-orange-500"
                  }`}
                >
                  <i className={`${checked.includes(i) ? "ri-thumb-up-fill" : "ri-thumb-up-line"} text-sm`} />
                  {checked.includes(i) ? "有帮助" : "有帮助?"}
                </button>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}